import {
    AbstractHttpClient,
    AbstractStorage,
    AbstractTokenManager,
    DefaultTokenManager,
    Translator,
} from "@clairejs/client";
import {
    AbstractLogger,
    AbstractProvider,
    ConsoleLogMedium,
    DefaultLogger,
    getServiceProvider,
    LogLevel,
    Provider,
    setSystemLocale,
} from "@clairejs/core";
import { ClaireApp, I18n } from "@clairejs/react";
import { LocalStorage, ReactWebRoutes } from "@clairejs/react-web";
import { createRoot } from "react-dom/client";

import { config } from "./config/config";

import en from "./assets/translations/en.json";
import vi from "./assets/translations/vi.json";

import "./utils/error-handler";

import "./index.scss";
import routes from "./routers";
import { ApiClient } from "./utils/api-client";
import { DataStore } from "./store/store";

@Provider(AbstractLogger)
export class LoggerProvider extends AbstractProvider<AbstractLogger> {
    provide(): AbstractLogger {
        return new DefaultLogger(LogLevel.DEBUG, [new ConsoleLogMedium()]);
    }
}

@Provider(AbstractHttpClient)
export class HttpClientProvider extends AbstractProvider<AbstractHttpClient> {
    constructor(readonly logger: AbstractLogger, readonly tokenManager: AbstractTokenManager) {
        super();
    }

    provide(): AbstractHttpClient {
        return new ApiClient(config.API_SERVER_URL, this.tokenManager, this.logger);
    }
}

@Provider(AbstractTokenManager)
export class TokenManagerProvider extends AbstractProvider<AbstractTokenManager> {
    constructor(readonly storage: AbstractStorage) {
        super();
    }

    provide(): AbstractTokenManager {
        return new DefaultTokenManager(this.storage);
    }
}

const bootstrap = async () => {
    const serviceProvider = getServiceProvider();
    serviceProvider.register(LocalStorage);
    serviceProvider.register(Translator);

    setSystemLocale("vi");

    const injector = serviceProvider.getInjector();
    await injector.initInstances();
};

const container = document.getElementById("root")!;

createRoot(container).render(
    <ClaireApp bootstrap={bootstrap} stores={[DataStore]}>
        <I18n
            translations={{
                vi: Promise.resolve<any>(vi),
                en: Promise.resolve<any>(en),
            }}>
            <ReactWebRoutes routeConfig={routes} />
        </I18n>
    </ClaireApp>,
);
